// extracted by mini-css-extract-plugin
export default {"root":"fullScreenPortal_root__UdF8R","nonePointerEvents":"fullScreenPortal_nonePointerEvents__Hzge4"};